import { h } from "preact";
import { Row } from "antd";
import { AuditOutlined } from "@ant-design/icons";
import { color } from "../../../../resources/color";
import { useGetCountReversation } from "../../hook/useGetCountReservation";
import { useEffect } from "preact/hooks";
import { ISummary } from "../../interfaces/summary";
import ShowCard from "../../../../components/card";

const Summary = ({ data }: ISummary) => {
  const {
    onFetchCountReservation,
    countComplete,
    countNotConfirmChange,
    countWaitInvoice,
    countWaitSaleOrder,
    countDeviceSaleOrder
  } = useGetCountReversation();

  useEffect(() => {
    onFetchCountReservation();
  }, [data]);

  return (
    <Row justify="center" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      <ShowCard
        labelHeader={"จำนวนเครื่องทั้งหมด"}
        iconTitle={<AuditOutlined />}
        color={color.main}
        count={countDeviceSaleOrder}
      />
      <ShowCard
        labelHeader={"ไม่คอนเฟิร์มจอง"}
        iconTitle={<AuditOutlined />}
        color={color.btn_hover_primary}
        count={countNotConfirmChange}
      />
      <ShowCard
        labelHeader={"รอออก SaleOrder"}
        iconTitle={<AuditOutlined />}
        color={color.mustardYellow}
        count={countWaitSaleOrder}
      />
      <ShowCard
        labelHeader={"รอออก Invoice"}
        iconTitle={<AuditOutlined />}
        color={color.orange}
        count={countWaitInvoice}
      />
      <ShowCard
        labelHeader={"จองเรียบร้อยแล้ว"}
        iconTitle={<AuditOutlined />}
        color={color.green}
        count={countComplete}
      />
    </Row>
  );
};

export default Summary;
